import { uploadData } from "@aws-amplify/storage";

import { createResizeImageFile } from "./resize-image";

import type { S3Object } from "../gql/__generated__/graphql";

export function getS3ObjectByKey(key: string) {
	return {
		bucket: import.meta.env.VITE_STORAGE_AWSS3_BUCKET,
		key,
		region: import.meta.env.VITE_STORAGE_AWSS3_REGION,
	};
}
/**
 * @param path パス
 * @param fileName 保存するファイル(名拡張子なし)
 * @param file ファイルオブジェクトの実態
 */
export async function uploadPublicImg(path: string, fileName: string, file: File): Promise<S3Object> {
	const suffix: string = file.name.split(".").pop()!;

	/**
	 * 画像のリサイズ
	 */
	const { resizedImageFile } = await createResizeImageFile({ file });

	// 画像のupload
	await uploadData({
		key: `${path}/${fileName}.${suffix}`,
		data: resizedImageFile,
		options: {
			accessLevel: "guest",
		},
	}).result;

	// s3objectの返信
	return {
		bucket: import.meta.env.VITE_STORAGE_AWSS3_BUCKET,
		key: `public/${path}/${fileName}.${suffix}`,
		region: import.meta.env.VITE_STORAGE_AWSS3_REGION,
	};
}

export function getImageUrl(s3Object: S3Object): string {
	if (!s3Object || !s3Object.key) {
		return "";
	}
	return `${import.meta.env.VITE_STORAGE_AWSS3_BASE_URL}${s3Object.key}`;
}
